import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { MenuController } from "@ionic/angular";
import { APIService } from "../apiservices/apiservices";
import { GlobalService } from "../apiservices/globalservices";
import { LocalStorageProvider } from "../apiservices/localstorageprovider";
import { ControleService } from "../controleciente/controle.service";

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private menuCtrl: MenuController,
    private storage: LocalStorageProvider,
    private globalService: GlobalService,
    private ControleService: ControleService
  ) {}

  public appMenuPages = [
    { title: 'Início', url: '/home', path: 'home', icon: 'file-tray-full-outline', count: 0, idModulo: 1 },
    { title: 'Comunicação', url: '/comunicacao', path: 'comunicacao', icon: 'chatbox-outline', count: 0, idModulo: 6 },
    { title: 'Autorização de serviço', url: '/autorizacao', path: 'autorizacao', icon: 'id-card-outline', count: 0, idModulo: 8 },
    { title: 'Informe de vendas', url: '/informe', path: 'informe', icon: 'bar-chart-outline', count: 0, idModulo: 2 },
    { title: 'Biblioteca', url: '/biblioteca', path: 'biblioteca', count: 0, idModulo: 7  },
    { title: 'Shoppings', url: '/shoppings', path: 'shoppings', icon: 'storefront-outline', count: 0, idModulo:4 },
    { title: 'Usuários', url: '/usuarios', path: 'usuarios', icon: 'people-circle-outline', count: 0, idModulo:3 },
    { title: 'IA Comunicação', url: '/iacomunicacao', path: 'iacomunicacao', icon: 'sparkles-outline', count: 0 , idModulo:6},
    { title: 'Boletos e Cobrança', url: '/cobranca', path: 'cobranca', icon: 'card-outline', count: 0, idModulo:5  },
    { title: 'Dashboard Multi', url: '/dashboard-multi', path: 'dashboard-multi', count: 0, idModulo: 10  },
    { title: 'Auditoria', url: '/auditoria', path: 'auditoria', icon: 'shield-outline', count: 0, idModulo:1 }

  ];
  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    let { Usuario, Config } = this.storage.loggedUser;

    if (Usuario) {
      APIService.UsuarioLogado.Usuario = Usuario;
      APIService.UsuarioLogado.TOKENJWT = Config.token;
      APIService.UsuarioLogado.dataToken = Config.dataToken;

      var data = Config.dataToken;
      var dtAtual = new Date();
      var dtToken = new Date(data);

      if (dtAtual > dtToken) {
        this.router.navigate(['login']);
        return false;
      } else {
        await this.ControleService.openModalControle(true);

        const moduleToAccess = this.appMenuPages.find(x => x.path == route.routeConfig.path);

        if (!moduleToAccess) {
          this.globalService.carregMenuEvent(null);
          this.menuCtrl.enable(true);
          return true;
        }

        if(moduleToAccess)
        {
          if(APIService.ValidarAcessoUsuario({
            id_modulo: moduleToAccess.idModulo,
          })){
            this.globalService.carregMenuEvent(null);
            this.menuCtrl.enable(true);
            return true;
          }
          else {
            //console.log('Acesso não autorizado ', moduleToAccess)
            if(APIService.ValidarAcessoUsuario({
              id_modulo: 1,
            })){

            this.globalService.carregMenuEvent(null);
            this.menuCtrl.enable(true);
              this.router.navigate(['home']);
              return false;
            }
            else if(APIService.ValidarAcessoUsuario({
              id_modulo: 2,
            })){
              this.globalService.carregMenuEvent(null);
              this.menuCtrl.enable(true);
              this.router.navigate(['informe']);
              return false
            }
          }
        }
      }
    } else {
      this.router.navigate(['login']);
      return false;
    }

    //return true;
  }
}
